import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/memberships/setup/$member-number/')({
  beforeLoad: (ctx) => {
    const { 'member-number': memberNumber } = ctx.params;
    throw redirect({
      to: '/memberships/setup/$member-number/aliases',
      params: { 'member-number': memberNumber }
    });
  }
});
